module.exports = {
    "apiurl":"http://localhost:3004",
    "oktaurl": "https://dev-411895.oktapreview.com",
    "oktaissuer": "https://dev-411895.oktapreview.com/oauth2/default",
    "redirecturi": window.location.origin + "/implicit/callback",
    "clientid": "0oann0bjxmOf9dFqj0h7"
}


// WEBPACK FOOTER //
// ./src/config/app.config.js